import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Button, Paper } from "@mui/material";
import BaseApi from "../../../../functions/axios";
import { useNavigate } from "react-router-dom";
import "../../../../style/arrow.css";

export default function UserList() {
  const [userList, setUserList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    BaseApi.get("user_list")
      .then((response) => {
        setUserList(response.data.data.user_list);
      })
      .catch((err) => {
        console.log("err:", err);
      });
  }, []);

  return (
    <div style={{ position: "relative" }}>
      {userList
        .filter((user) => user.admin_flag !== 9) // 管理者を除外
        .map((user) => (
          <Paper key={user.id || user.email}>
            <Button
              variant="text"
              sx={{
                width: "100%",
                bgcolor: "#fff",
                color: "#1f1f1f",
                borderBottom: 1,
                borderColor: "#F2F3F4",
                paddingTop: "15px",
                paddingBottom: "15px",
                ":hover": {
                  boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.3)",
                  zIndex: 1,
                },
              }}
              onClick={() => {
                navigate("adminChangeUserInfo", {
                  state: { user },
                });
              }}
            >
              <Grid container justify="center" textAlign="center">
                <Grid item xs={1.5} fontSize="14px" textTransform="none" textAlign="left">
                  {user.name}
                </Grid>
                <Grid item xs={3} paddingLeft="15px" fontSize="14px" textTransform="none" textAlign="left">
                  {user.email}
                </Grid>
                <Grid item xs={1} fontSize="14px" textAlign="center">
                  <div>
                    {user.admin_flag === Number(process.env.REACT_APP_GENERAL_CLASS) && "一般ユーザ"}
                    {user.admin_flag === Number(process.env.REACT_APP_BP_MANAGEMENT_CLASS) && "BP管理者"}
                  </div>
                </Grid>
                <Grid item xs={2} fontSize="14px" textAlign="center">
                  {user.created_at && (
                    <div>
                      {user.created_at.substring(0, 4)}年{user.created_at.substring(5, 7)}月{user.created_at.substring(8, 10)}日
                    </div>
                  )}
                </Grid>
                <Grid item xs={1.5} fontSize="14px" textAlign="center">
                  {user.notification_flag === 1 ? "通知する" : "通知しない"}
                </Grid>
                <Grid item xs={2} fontSize="14px" textAlign="center">
                  {user.last_login && (
                    <div>
                      {user.last_login.substring(0, 4)}年{user.last_login.substring(5, 7)}月{user.last_login.substring(8, 10)}日
                      <br />
                      {user.last_login.substring(11, 13)}時{user.last_login.substring(14, 16)}分
                    </div>
                  )}
                </Grid>
                <Grid item xs={1} fontSize="16px" alignItems="center">
                  <p className="arrow"></p>
                </Grid>
              </Grid>
            </Button>
          </Paper>
        ))}
    </div>
  );
}